import { addToast } from '@heroui/react';

/***
 * This shim mimics the 'react-hot-toast' API that was previously used.
 * This allows us to replace 'react-hot-toast' with '@heroui/react' toasts
 * without changing all of the existing toast calls in the codebase.
 */
const toast = {
  success: (message: string) => {
    addToast({ description: message, color: 'success' });
  },
  error: (message: string) => {
    addToast({ description: message, color: 'danger' });
  },
};

export default toast;
